var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-textarea"},[_c('vue-tribute',{attrs:{"options":Object.assign({}, _vm.tributeOptions)}},[_c('textarea',{ref:"gg",staticClass:"el-textarea__inner",attrs:{"type":"textarea","data-tribute":"true"},on:{"blur":_vm.blur}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b7527a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard/ReportsOneComplete/Comments.vue
// module id = null
// module chunks = 